import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Col,
  Row,
  Form,
  Space,
  Button,
  Upload,
  Input,
  message,
  Typography,
  Tooltip,
  Dropdown,
  MenuProps,
  Menu,
} from "antd";
import utc from "dayjs/plugin/utc";

import { useForm, Controller, useController } from "react-hook-form";
import {
  DateField,
  InputCheckbox,
  InputCheckboxGroup,
  InputField,
  InputRadio,
  ReactSelectField,
  TextAreaField,
  TimeField,
  TimeRangeField,
} from "../../../atoms/FormElement";
import cronstrue from "cronstrue";
import { LoaderIcon } from "../../../atoms/Icons";
import { DeleteOutlined, InfoCircleOutlined } from "@ant-design/icons";
import TemplatePreview from "../../../atoms/TemplatePreview";
import axios from "axios";
import { portalService } from "../../../../configs/constants";
import { uploadDocumentMedia, uploadToS3 } from "../../../../utils/media";
import { sendBulkNotification } from "../ducks/actions";
import { Radio } from "antd/es";
import dayjs from "dayjs";

dayjs.extend(utc);
const { Item } = Menu;

const TemplateComm = React.memo((props: any) => {
  const [csvFile, setCsvFile] = useState([]);
  const [imageFiles, setImageFiles] = useState({});
  const [fileData, setFileData] = useState(null);
  const [popnoti, setPopnoti] = useState([]);
  const [loader, setLoader] = useState(false);
  const [loader1, setLoader1] = useState({});
  const {
    control,
    handleSubmit,
    setValue,
    reset,
    watch,
    getValues,
    formState: { errors },
  } = useForm({
    shouldUnregister: false,
    // defaultValues: {
    //   dropdown: { label: "weeks", key: "weeks" },
    //   title: "",
    //   type: 1,
    //   frequency: 1,
    //   message: "",
    //   status: "Info",
    //   notiStatus: "1",
    // },
  });

  const { field } = useController({
    name: "dropdownRepeat",
    control,
    defaultValue: "Weeks", // Set default value here
  });

  const menu = (
    <Menu
      onClick={({ key }) => field.onChange(key)} // Handle selection here
      items={[{ label: "Weeks", key: "Weeks" }]}
    />
  );

  const [currentTemplate, setCurrentTemplate] = useState({
    html: "",
    variables: {},
  });

  const title = watch("title", "");
  const type = watch("type", 1);
  const repeatWatcher = watch("repeat", 1);
  const frequency = watch("frequency", 1);
  const timeOfNotiWatcher = watch("timeOfNoti", null);
  const typesWatcher = watch("types", "");
  const startDateWatcher = watch("startDate", "");
  const endDateWatcher = watch("endDate", "");
  const monthDaysWatcher = watch("monthDays", "");
  const messageField = watch("message", "");
  const status = watch("status", "Info");
  const endTimeWatcher = watch("endTime", "");
  const dropdownRepeatWatcher = watch("dropdownRepeat", "2");

  const templateWatcher = watch("template", "");
  const selectedDaysWatcher = watch("selectedDays", "");
  const cronMinWatcher = watch("cronMinRepeat", "*");
  const cronHourRepeatWatcher = watch("cronHourRepeat", "*");
  const cronDayMonthWatcher = watch("cronDayMonthRepeat", "*");
  const cronMonthWatcher = watch("cronMonthRepeat", "*");
  const cronDayWeekWatcher = watch("cronDayWeekRepeat", "*");

  const days = [
    { label: "MON", value: "MON", checked: false },
    { label: "TUE", value: "TUE", checked: false },
    { label: "WED", value: "WED", checked: false },
    { label: "THU", value: "THU", checked: false },
    { label: "FRI", value: "FRI", checked: false },
    { label: "SAT", value: "SAT", checked: false },
    { label: "SUN", value: "SUN", checked: false },
  ];
  const date = [
    { label: "1", value: "1", checked: false },
    { label: "2", value: "2", checked: false },
    { label: "3", value: "3", checked: false },
    { label: "4", value: "4", checked: false },
    { label: "5", value: "5", checked: false },
    { label: "6", value: "6", checked: false },
    { label: "7", value: "7", checked: false },
    { label: "8", value: "8", checked: false },
    { label: "9", value: "9", checked: false },
    { label: "10", value: "10", checked: false },
    { label: "11", value: "11", checked: false },
    { label: "12", value: "12", checked: false },
    { label: "13", value: "13", checked: false },
    { label: "14", value: "14", checked: false },
    { label: "15", value: "15", checked: false },
    { label: "16", value: "16", checked: false },
    { label: "17", value: "17", checked: false },
    { label: "18", value: "18", checked: false },
    { label: "19", value: "19", checked: false },
    { label: "20", value: "20", checked: false },
    { label: "21", value: "21", checked: false },
    { label: "22", value: "22", checked: false },
    { label: "23", value: "23", checked: false },
    { label: "24", value: "24", checked: false },
    { label: "25", value: "25", checked: false },
    { label: "26", value: "26", checked: false },
    { label: "27", value: "27", checked: false },
    { label: "28", value: "28", checked: false },
    { label: "29", value: "29", checked: false },
    { label: "30", value: "30", checked: false },
    { label: "31", value: "31", checked: false },
  ];
  const dayMapping = {
    MON: 1,
    TUE: 2,
    WED: 3,
    THU: 4,
    FRI: 5,
    SAT: 6,
    SUN: 0,
  };

  const watchedVariables = watch(
    Object.keys(currentTemplate.variables).map((key) => `variables.${key}`),
    Object.entries(currentTemplate.variables).reduce((acc, [key, value]) => {
      acc[`variables.${key}`] = value;
      return acc;
    }, {})
  );

  function generateCronString(selectedDays, hour = 9, minute = 0) {
    const selectedNumbers = selectedDays
      .map((day) => dayMapping[day])
      .join(",");
    return `${minute} ${hour} * * ${selectedNumbers}`;
  }
  function generateCronStringFormonthly(selectedDays, hour = 9, minute = 0) {
    const selectedNumbers = "" + selectedDays;
    return `${minute} ${hour} ${selectedNumbers} * *`;
  }

  useEffect(() => {
    if (typesWatcher?.length > 0 && timeOfNotiWatcher) {
      let [hours, minutes] = timeOfNotiWatcher.format("HH:mm").split(":");
    }
  }, [typesWatcher, timeOfNotiWatcher]);

  function resetAll() {
    setFileData(null);
    setImageFiles({});
    setCsvFile([]);
    setCurrentTemplate({ html: "", variables: {} });
    reset();
  }

  const fetchTemplates = async () => {
    try {
      const response = await axios.post(`${portalService}/lov`, {
        filter: { keyGroup: "POPNOTI" },
        projection: { value: 1, label: "$label.EN", _id: 0, attributes: 1 },
      });
      setPopnoti(response.data || []);
    } catch (error) {
      message.error("Failed to load templates.");
    }
  };

  useEffect(() => {
    fetchTemplates();
  }, []);

  const handleTemplateChange = (e) => {
    const selectedTemplate = popnoti.find((item) => item.value === e.value);
    if (selectedTemplate) {
      const { html, ...variables } = selectedTemplate.attributes;
      setCurrentTemplate({ html, variables });
      Object.entries(variables).forEach(([key, value]) =>
        setValue(`variables.${key}`, value)
      );
    }
  };

  const generalFileProps = (fileState, setFileState, fileType) => ({
    name: "file",
    multiple: false,
    accept: fileType === "image" ? "image/*" : ".csv",
    showUploadList: false,
    fileList: fileState || [],
    onChange: ({ fileList }) => {
      const latestFile = fileList?.[fileList.length - 1];
      if (latestFile) {
        if (fileType === "image" && !latestFile.type.startsWith("image/")) {
          message.error("Please upload an image file only.");
          return;
        }
        if (fileType === "csv" && latestFile.type !== "text/csv") {
          message.error("Please upload a CSV file only.");
          return;
        }

        setFileState([latestFile]);
      }
    },
    onRemove: () => fileState.length && setFileState([]), // Reset if not already empty
    beforeUpload: () => false, // Prevent default file upload behavior
  });

  const getPresigned = async (file, fileType, key = "") => {
    try {
      const { data } = await uploadDocumentMedia({
        name: file.name,
        mimetype: file.type,
      });
      if (data?.documentId && data?.signedUrl) {
        await uploadToS3(data.signedUrl, file);
        setFileData((prev) => ({
          ...prev,
          [fileType]: {
            ...prev?.[fileType],
            [key]: data,
          },
        }));
        if (data?.location) setValue(`variables.${key}`, data?.location);
      }
    } catch (error) {
      console.error("Upload error:", error);
    }
  };

  const checkFormValidity = () => {
    let valid: boolean = false;
    if (type === 1) {
      valid =
        !!messageField &&
        !!title &&
        !!status?.value &&
        !!templateWatcher?.value;
    } else if (type === 2) {
      valid = false;
      if (frequency == 1) {
        valid =
          !!messageField &&
          !!title &&
          !!status?.value &&
          !!templateWatcher?.value &&
          !!frequency &&
          selectedDaysWatcher &&
          selectedDaysWatcher?.length > 0 &&
          !!timeOfNotiWatcher &&
          !!startDateWatcher &&
          !!endDateWatcher;
      }
      if (frequency == 2) {
        valid =
          !!messageField &&
          !!title &&
          !!status?.value &&
          !!templateWatcher?.value &&
          !!repeatWatcher &&
          selectedDaysWatcher &&
          selectedDaysWatcher?.length > 0 &&
          !!timeOfNotiWatcher &&
          !!startDateWatcher &&
          !!endDateWatcher;
      } else if (frequency == 3) {
        valid =
          !!messageField &&
          !!title &&
          !!status?.value &&
          !!templateWatcher?.value &&
          !!monthDaysWatcher &&
          monthDaysWatcher?.length > 0 &&
          !!timeOfNotiWatcher &&
          !!startDateWatcher &&
          !!endDateWatcher;
      } else if (frequency == 4) {
        valid =
          !!messageField &&
          !!title &&
          !!status?.value &&
          !!templateWatcher?.value &&
          !!cronHourRepeatWatcher &&
          !!cronDayMonthWatcher &&
          !!cronMonthWatcher &&
          !!cronDayWeekWatcher;
      }
    }
    return !valid;
  };

  useEffect(() => {
    if (type === 2 && startDateWatcher && endDateWatcher) {
      if (timeOfNotiWatcher) {
        if (frequency == 1 && selectedDaysWatcher?.length > 0) {
          let [hours, minutes] = timeOfNotiWatcher.format("HH:mm").split(":");

          const stringVal = generateCronString(
            selectedDaysWatcher,
            hours,
            minutes
          );
          console.log("cron string = ", stringVal);

          setValue("cronMinRepeat", stringVal.split(" ")[0]);
          setValue("cronHourRepeat", stringVal.split(" ")[1]);
          setValue("cronDayMonthRepeat", stringVal.split(" ")[2]);
          setValue("cronMonthRepeat", stringVal.split(" ")[3]);
          setValue("cronDayWeekRepeat", stringVal.split(" ")[4]);
        } else if (frequency == 2 && selectedDaysWatcher?.length > 0) {
          if (
            !isNaN(repeatWatcher) &&
            +repeatWatcher > 0 &&
            +repeatWatcher < 4
          ) {
            let [hours, minutes] = timeOfNotiWatcher.format("HH:mm").split(":");
            const stringVal =
              generateCronString(selectedDaysWatcher, hours, minutes) +
              "/" +
              repeatWatcher;
            setValue("cronMinRepeat", stringVal.split(" ")[0]);
            setValue("cronHourRepeat", stringVal.split(" ")[1]);
            setValue("cronDayMonthRepeat", stringVal.split(" ")[2]);
            setValue("cronMonthRepeat", stringVal.split(" ")[3]);
            setValue("cronDayWeekRepeat", stringVal.split(" ")[4]);
          }
        } else if (frequency == 3 && monthDaysWatcher?.length > 0) {
                let [hours, minutes] = timeOfNotiWatcher.format("HH:mm").split(":");
            const stringVal =
              generateCronStringFormonthly(monthDaysWatcher, hours, minutes) +
              "/" +
              repeatWatcher;
            setValue("cronMinRepeat", stringVal.split(" ")[0]);
            setValue("cronHourRepeat", stringVal.split(" ")[1]);
            setValue("cronDayMonthRepeat", stringVal.split(" ")[2]);
            setValue("cronMonthRepeat", stringVal.split(" ")[3]);
            setValue("cronDayWeekRepeat", stringVal.split(" ")[4]);
        }
      }
    }
  }, [
    type,
    startDateWatcher,
    endDateWatcher,
    frequency,
    selectedDaysWatcher,
    timeOfNotiWatcher,
    monthDaysWatcher,
    endTimeWatcher,
  ]);

  useEffect(() => {
    const uploadCsv = async () => {
      const file = csvFile[0]?.originFileObj;
      if (file) {
        setLoader(true);
        await getPresigned(file, "csv", "csv_file");
        setLoader(false);
      }
    };
    uploadCsv();
  }, [csvFile]);

  const uploadImages = async (key, fileObj) => {
    const file = fileObj?.originFileObj;
    setLoader1({ [key]: true });
    if (file) await getPresigned(file, "image", key);
    setLoader1({ [key]: false });
  };

  const renderVariables = useMemo(() => {
    return Object.entries(currentTemplate.variables).map(([key, value]) => (
      <Col span={24} key={key} style={{ paddingBottom: "10px" }}>
        {key.endsWith("_img") ? (
          <Space size={0}>
            <Upload
              {...generalFileProps(
                imageFiles[key] || [],
                (fileList) => {
                  setImageFiles((prev) =>
                    prev[key] === fileList
                      ? prev
                      : {
                          ...prev,
                          [key]: [fileList[fileList?.length - 1]],
                        }
                  );
                  uploadImages(key, fileList[fileList?.length - 1]);
                },
                "image"
              )}
            >
              {" "}
              <Space size={0}>
                <Input
                  readOnly
                  value={imageFiles[key]?.[0]?.name}
                  placeholder={`Upload ${key.replace("_img", " image")}`}
                  disabled={loader1[key]}
                />
                <Button disabled={loader1[key]}>Browse</Button>
              </Space>
            </Upload>
            &nbsp;&nbsp;
            {loader1[key] && <LoaderIcon />}
            {imageFiles[key]?.length > 0 && !loader1[key] && (
              <Button
                type="link"
                icon={<DeleteOutlined />}
                onClick={(e) => {
                  e.preventDefault();
                  setImageFiles({ ...imageFiles, [key]: [] });
                }}
              />
            )}
          </Space>
        ) : (
          <TextAreaField
            label={`Enter ${key}`}
            fieldname={`variables.${key}`}
            iProps={{
              placeholder: `Enter ${key}`,
              as: "textarea",
              rows: 4,
              onKeyDown: (e) => {
                if (e.key === "Enter") {
                  const value = e.target.value;

                  if (value.endsWith("\n")) {
                    e.preventDefault();
                  }
                }
              },
            }}
            initValue={value || ""}
            control={control}
          />
        )}
      </Col>
    ));
  }, [currentTemplate.variables, imageFiles, loader1, control]);
  const onFinish = async (values) => {
    let payload = null;
    if (!csvFile?.length || !fileData?.csv?.csv_file) {
      message.info("Please upload a CSV file first");
      return;
    }
    if (values.type === 1) {
      payload = {
        types: ["POPNOTIFICATION"],
        message: values.message,
        title: values.title,
        CSVFile: {
          id: fileData.csv?.csv_file?.documentId,
          size: csvFile[0]?.size,
        },
        priority: 2,
        data: {
          templateId: "Status",
          status: values?.status?.value || "info",
          html: values?.data?.html || "",
        },
      };
    } else {
      const endTimeHour = timeOfNotiWatcher?.hour();
      const endTimeMin = timeOfNotiWatcher?.minute();
      payload = {
        types: ["POPNOTIFICATION"],
        message: values.message,
        title: values.title,
        CSVFile: {
          id: fileData.csv?.csv_file?.documentId,
          // id: 'documentId_ead808e0-bfe9-4a3d-96a5-8030257108a8',
          size: csvFile[0]?.size,
        },
        priority: 1, // hardcode this value
        data: {
          templateId: "Status",
          status: values?.status?.value || "info",
          html: values.data.html,
        },
        scheduler: {
          name: values.notificationName,
          cronExpression: `${values.cronMinRepeat} ${values.cronHourRepeat} ${values.cronDayMonthRepeat} ${values.cronMonthRepeat} ${values.cronDayWeekRepeat}`,
          timezone: "UTC",
          startDate: dayjs(values.timeOfNoti)
            .utc()
            .format("YYYY-MM-DDTHH:mm:ss[Z]"),
          endDate: dayjs(values.endDate)
            .set("hour", endTimeHour)
            .set("minute", endTimeMin)
            .endOf("day")
            .format("YYYY-MM-DDTHH:mm:ss[Z]"),
        },
      };
    }
    message.loading("Sending...");
    console.log("payload", payload);
    try {
      await sendBulkNotification(payload);
      message.destroy();
      message.success("Successfully sent");
      resetAll();
    } catch (error) {
      message.destroy();
      message.error("Failed to send. Please try again.");
      console.error("Error:", error);
    }
  };
  return (
    <>
      <Form layout="vertical" onFinish={handleSubmit(onFinish)}>
        <Row gutter={24}>
          <Col span={14}>
            <Row gutter={24}>
              <Col span={12}>
                Upload CSV with driverId or company-code&nbsp;{" "}
                <Tooltip
                  title={"Accepts values: driverId(s), Company-codes, all"}
                  arrow={false}
                >
                  <InfoCircleOutlined />
                </Tooltip>
                <Space size={0} style={{ paddingTop: "13px" }}>
                  <Upload
                    showUploadList={false}
                    {...generalFileProps(csvFile, setCsvFile, "csv")}
                  >
                    <Space size={0}>
                      <Input
                        readOnly
                        value={csvFile?.[0]?.name}
                        placeholder="Choose a file to upload"
                        disabled={loader}
                      />
                      <Button className="ag-gray-button" disabled={loader}>
                        Browse
                      </Button>
                    </Space>
                  </Upload>
                  &nbsp;&nbsp;
                  {loader && <LoaderIcon />}
                  {csvFile?.length > 0 && !loader && (
                    <Button
                      type="link"
                      icon={<DeleteOutlined />}
                      onClick={(e) => {
                        e.preventDefault();
                        setCsvFile([]);
                      }}
                    />
                  )}
                </Space>
              </Col>
              <Col
                span={12}
                className="main-checkbox"
                style={{
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <ReactSelectField
                  fieldname="template"
                  style={{ width: "250px" }}
                  label="Please select a message template"
                  control={control}
                  initValue={""}
                  selectOption={popnoti.map((e) => ({
                    label: e.label,
                    value: e.value,
                  }))}
                  onChange={handleTemplateChange}
                  isRequired={true}
                  rules={{ required: "Please select template" }}
                  validate={errors.template && "error"}
                  validMessage={errors.template && errors.template.message}
                />
              </Col>

              <Col span={14}>
                <div
                  onKeyDown={(e) => {
                    if (e.key === "Enter") e.preventDefault();
                  }}
                >
                  <InputField
                    label="Title"
                    fieldname="title"
                    iProps={{ placeholder: "Enter title" }}
                    maxLength={70}
                    initValue=""
                    isRequired={true}
                    control={control}
                    rules={{ required: "Title Required" }}
                    validate={errors.title && "error"}
                    validMessage={errors.title && errors.title.message}
                  />
                </div>
              </Col>

              <Col
                span={10}
                style={{
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <ReactSelectField
                  fieldname="status"
                  style={{ width: "250px" }}
                  label="Status"
                  control={control}
                  initValue={{
                    label: <div style={{ color: "#1890ff" }}>Info</div>,
                    value: "info",
                  }}
                  selectOption={[
                    {
                      label: <div style={{ color: "#1890ff" }}>Info</div>,
                      value: "info",
                    },
                    {
                      label: <div style={{ color: "#faad14" }}>Warning</div>,
                      value: "warn",
                    },
                    {
                      label: <div style={{ color: "#06b460" }}>Success</div>,
                      value: "success",
                    },
                    {
                      label: <div style={{ color: "#f5222d" }}>Failed</div>,
                      value: "failed",
                    },
                  ]}
                />
              </Col>

              <Col span={24}>
                <TextAreaField
                  label="Enter subtitle"
                  fieldname="message"
                  iProps={{
                    placeholder: "Write your message",
                    as: "textarea",
                    rows: 4,
                    onKeyDown: (e) => {
                      if (e.key === "Enter") {
                        const value = e.target.value;

                        // if last character is a newline, block another enter
                        if (value.endsWith("\n")) {
                          e.preventDefault();
                        }
                      }
                    },
                  }}
                  initValue=""
                  control={control}
                  maxLength={150}
                  isRequired={true}
                  rules={{ required: "Message Required" }}
                  validate={errors.message && "error"}
                  validMessage={errors.message && errors.message.message}
                />
              </Col>

              {Object.entries(currentTemplate.variables).length > 0 && (
                <Col span={24}>
                  {/* <Title level={5}>Template Variables</Title> */}
                </Col>
              )}
              {renderVariables}
              <Col span={24}>
                <InputRadio
                  fieldname={"type"}
                  label={"Type"}
                  control={control}
                  rules={{ required: "Message Required" }}
                  initValue={type}
                  value={type}
                  isRequired={true}
                  validate={errors.message && "error"}
                  options={[
                    { value: 1, label: "Now" },
                    { value: 2, label: "Scheduled" },
                  ].map((option) => (
                    <Radio key={option.value} value={option.value}>
                      {option.label}
                    </Radio>
                  ))}
                  validMessage={errors.message && errors.message.message}
                />
              </Col>
              {type === 2 && (
                <>
                  <Col span={24} style={{ paddingBottom: 0 }}>
                    <InputRadio
                      fieldname={"frequency"}
                      label={"Frequency"}
                      control={control}
                      value={frequency}
                      initValue={frequency}
                      rules={{ required: "Message Required" }}
                      isRequired={true}
                      validate={errors.message && "error"}
                      options={[
                        { value: 1, label: "Daily" },
                        { value: 2, label: "Weekly" },
                        { value: 3, label: "Monthly" },
                        { value: 4, label: "Custom" },
                      ].map((option) => (
                        <Radio key={option.value} value={option.value}>
                          {option.label}
                        </Radio>
                      ))}
                      validMessage={errors.message && errors.message.message}
                    />
                  </Col>

                  <Col
                    span={12}
                    style={{
                      flexDirection: "row",
                      paddingBottom: 0,
                    }}
                  >
                    <InputField
                      value={""}
                      label={"Notifiacation Name"}
                      fieldname={"notificationName"}
                      iProps={{ placeholder: "Notification Name" }}
                      initValue=""
                      disabled={frequency !== 4}
                      control={control}
                      styles={{ textAlign: "center" }}
                      rules={{ required: "Title Required" }}
                      validate={errors.title && "error"}
                      validMessage={errors.title && errors.title.message}
                    />
                    <p
                      style={{
                        paddingLeft: "10px",
                      }}
                    ></p>
                  </Col>

                  {frequency === 1 && (
                    <Col
                      span={24}
                      style={{
                        flexDirection: "row",
                        paddingBottom: 0,
                      }}
                    >
                      <InputCheckboxGroup
                        fieldname="selectedDays"
                        label={"Selected Days"}
                        options={days}
                        initValue={""}
                        control={control}
                        iProps={{
                          isDisabled: !(csvFile?.length > 0) || loader,
                        }}
                        isRequired={true}
                        rules={{ required: "Please select one atleast" }}
                        validate={errors.types && "error"}
                        validMessage={errors.types && errors.types.message}
                      />
                      <p
                        style={{
                          paddingLeft: "10px",
                        }}
                      ></p>
                    </Col>
                  )}
                  {frequency === 2 && (
                    <>
                      <Col span={8} style={{ flexDirection: "row" }}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <InputField
                            style={{ width: "10%" }}
                            label="Repeat every"
                            fieldname="repeat"
                            iProps={{ placeholder: "1" }}
                            // maxLength={70}
                            initValue="1"
                            // isRequired={true}
                            control={control}
                            rules={{ required: "Title Required" }}
                            validate={errors.title && "error"}
                            validMessage={errors.title && errors.title.message}
                          />
                          <div
                            style={{
                              paddingTop: "10px",
                              paddingLeft: "10px",
                            }}
                          >
                            <Dropdown overlay={menu} trigger={["click"]}>
                              <Button>{field.value}</Button>
                            </Dropdown>
                          </div>
                        </div>
                      </Col>
                      {dropdownRepeatWatcher !== "Days" && (
                        <Col span={24}>
                          <InputCheckboxGroup
                            fieldname="selectedDays"
                            label={"Selected days"}
                            options={days}
                            initValue={""}
                            control={control}
                            iProps={{
                              isDisabled: !(csvFile?.length > 0) || loader,
                            }}
                            isRequired={true}
                            rules={{ required: "Please select one atleast" }}
                            validate={errors.types && "error"}
                            validMessage={errors.types && errors.types.message}
                          />
                        </Col>
                      )}
                    </>
                  )}

                  {frequency == 3 && (
                    <Col
                      span={24}
                      style={{
                        flexDirection: "row",
                        paddingBottom: 0,
                        display: frequency === 3 ? "flex" : "flex",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <InputCheckboxGroup
                          fieldname="monthDays"
                          label={"Selected Days"}
                          options={date}
                          initValue={""}
                          control={control}
                          iProps={{
                            isDisabled: !(csvFile?.length > 0) || loader,
                          }}
                          isRequired={true}
                          rules={{ required: "Please select one atleast" }}
                          validate={errors.types && "error"}
                          validMessage={errors.types && errors.types.message}
                        />
                      </div>
                    </Col>
                  )}
                  {frequency !== 4 && (
                    <Col span={24} style={{ display: "flex" }}>
                      <div
                        style={{
                          // display: "flex",
                          justifyContent: "space-between",
                          width: "20%",
                          paddingRight: "5px",
                        }}
                      >
                        <TimeField
                          defaultValue={dayjs().format()}
                          // format={format}
                          fieldname={"timeOfNoti"}
                          label={"Time"}
                          control={control}
                          iProps={{
                            isDisabled: false,
                          }}
                          rules={{ required: "Please select time" }}
                          initValue={""}
                          isRequired={true}
                          validate={errors.types && "error"}
                          validMessage={errors.types && errors.types.message}
                        />
                      </div>
                    </Col>
                  )}

                  <Col
                    span={12}
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div style={{ width: "40%" }}>
                      <DateField
                        label="Start Date"
                        fieldname="startDate"
                        isRequired={true}
                        control={control}
                        onChange={(e) => {
                          console.log("e", e);
                        }}
                        initValue={""}
                        iProps={{
                          placeholder: "DD-MM-YYYY",
                          format: "DD-MM-YYYY",
                          // disabledDate: disableCommenceDate,
                          // disabled: disableAll,
                        }}
                      />
                    </div>
                    <div style={{ width: "40%" }}>
                      <DateField
                        label="End Date"
                        fieldname="endDate"
                        control={control}
                        isRequired={true}
                        onChange={(e) => {
                          console.log("e", e);
                        }}
                        initValue={""}
                        iProps={{
                          placeholder: "DD-MM-YYYY",
                          format: "DD-MM-YYYY",
                          // disabledDate: disableCommenceDate,
                          // disabled: disableAll,
                        }}
                      />
                    </div>
                  </Col>
                </>
              )}
              {type === 2 && (
                <>
                  <Col
                    span={4}
                    style={{
                      paddingBottom: "0px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <p style={{ paddingBottom: "0px" }}>Cron String</p>
                  </Col>
                  <Col
                    span={24}
                    style={{
                      flexDirection: "row",
                      paddingBottom: 0,
                      display: frequency === 3 ? "flex" : "flex",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      {[
                        {
                          id: "cronMinRepeat",
                          label: "Min",
                          val: cronMinWatcher,
                        },
                        {
                          id: "cronHourRepeat",
                          label: "Hour",
                          val: cronHourRepeatWatcher,
                        },
                        {
                          id: "cronDayMonthRepeat",
                          label: "Day Month",
                          val: cronDayMonthWatcher,
                        },
                        {
                          id: "cronMonthRepeat",
                          label: "Month",
                          val: cronMonthWatcher,
                        },
                        {
                          id: "cronDayWeekRepeat",
                          label: "Day Week",
                          val: cronDayWeekWatcher,
                        },
                      ].map((item) => {
                        return (
                          <Col
                            span={3}
                            style={{
                              paddingBottom: 0,
                              display: "flex",
                              alignItems: "center",
                              padding: 0,
                              marginRight: 10,
                              justifyContent: "center",
                            }}
                          >
                            <InputField
                              value={item.val || "*"}
                              label={item.label}
                              fieldname={item.id}
                              iProps={{ placeholder: "*" }}
                              initValue="*"
                              disabled={frequency !== 4}
                              control={control}
                              styles={{ textAlign: "center" }}
                              rules={{ required: "Title Required" }}
                              validate={errors.title && "error"}
                              validMessage={
                                errors.title && errors.title.message
                              }
                            />
                          </Col>
                        );
                      })}
                    </div>
                  </Col>
                  <Col span={24}>
                    <p>
                      {cronMinWatcher &&
                        cronHourRepeatWatcher &&
                        cronDayMonthWatcher &&
                        cronMonthWatcher &&
                        cronDayWeekWatcher &&
                        cronstrue.toString(
                          `${cronMinWatcher} ${cronHourRepeatWatcher} ${cronDayMonthWatcher} ${cronMonthWatcher} ${cronDayWeekWatcher}`
                        )}
                    </p>
                  </Col>
                </>
              )}
              <Col
                span={24}
                style={{
                  marginTop: "5px",
                  marginBottom: "15px",
                  textAlign: "center",
                }}
              >
                <Button
                  className="ag-green-button theme_btn"
                  htmlType="submit"
                  disabled={checkFormValidity()}
                >
                  Submit
                </Button>
              </Col>
            </Row>
          </Col>
          <Col span={10}>
            <TemplatePreview
              {...currentTemplate}
              title={title}
              message={messageField}
              status={status?.value}
              setValue={setValue}
              editHtml={props?.editHtml}
              variables={Object.entries(currentTemplate.variables).reduce(
                (acc, [key], idx) => {
                  acc[key] = watchedVariables[idx];
                  return acc;
                },
                {}
              )}
            />
          </Col>
        </Row>
        <br />
        <br />
      </Form>
    </>
  );
});

export default TemplateComm;
